import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { Component, Fragment } from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { Button, Loader, EmptyState, Container, Text, Spacer, Animation } from '@vinted/web-ui';
import { ClickableElement } from 'constants/tracking/clickable-elements';
import { abTestExposeEvent, clickEvent } from 'libs/common/event-tracker/events';
import { withTracking } from 'containers/TrackingProvider';
import { Screen } from 'constants/tracking/screens';
import { getAbTestByName } from 'state/ab-tests/selectors';
import { getExposee } from 'state/session/selectors';
import { getIsFeatureSwitchEnabled } from 'state/feature-switches/selectors';
import { logMessage } from 'libs/utils/window';
import { ITEM_UPLOAD_URL } from 'constants/routes';
import { FormattedMessage } from 'components/@support';
import InfiniteScroll from 'components/InfiniteScroll';
import SortFilter from 'components/SortFilter';
import CatalogFilter from 'components/CatalogFilter';
import { withBreakpoint } from 'components/Breakpoint';
import { STATIC_ASSETS_URL } from 'constants/index';
import ItemsContainer from './ItemsContainer';
import UserItemsFilters from './UserItemsFilters';
import { UserItemsFilterType } from './UserItemsFilters/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const trackingElementByFilterType = {
  [UserItemsFilterType.Active]: ClickableElement.FilterActive,
  [UserItemsFilterType.Hidden]: ClickableElement.FilterHidden,
  [UserItemsFilterType.Sold]: ClickableElement.FilterSold,
  [UserItemsFilterType.Reserved]: ClickableElement.FilterReserved,
  [UserItemsFilterType.Draft]: ClickableElement.FilterDrafts
};

const mapStateToProps = state => ({
  closetFilteringAbTest: getAbTestByName('closet_filtering')(state),
  isClosetFilteringEnabled: getIsFeatureSwitchEnabled('closet_filtering_web')(state),
  exposee: getExposee(state)
});

const connector = connect(mapStateToProps);

class UserItems extends Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "state", {
      selectedFilter: undefined,
      isClientSideReady: false
    });

    _defineProperty(this, "isViewingSelf", () => this.props.currentUserId === this.props.userId);

    _defineProperty(this, "handleFilterChange", filterKey => newValue => {
      this.props.updateFilters(_objectSpread(_objectSpread({}, this.props.filters), {}, {
        [filterKey]: newValue
      }));
    });

    _defineProperty(this, "handleUserItemsFilterClick", filter => {
      const {
        selectedFilter
      } = this.state;
      const {
        fetchMore,
        track
      } = this.props;
      const newFilter = selectedFilter === filter ? undefined : filter;
      const trackingEvent = clickEvent({
        target: trackingElementByFilterType[filter],
        screen: Screen.CurrentUserProfile
      });
      if (selectedFilter !== filter) track(trackingEvent);
      logMessage("Closet filter clicked: ".concat(filter), {
        feature: 'closet_filtering',
        extra: filter || 'all'
      });
      this.setState({
        selectedFilter: newFilter
      });
      fetchMore(newFilter);
    });

    _defineProperty(this, "fetchMoreItems", () => {
      const {
        fetchMore
      } = this.props;
      const {
        selectedFilter
      } = this.state;
      fetchMore(selectedFilter);
    });

    _defineProperty(this, "renderItemsContainer", () => {
      const {
        items,
        userId,
        allowBump
      } = this.props;
      return /*#__PURE__*/_jsx(ItemsContainer, {
        items: items,
        userId: userId,
        allowBump: allowBump,
        isViewingSelf: this.isViewingSelf()
      });
    });

    _defineProperty(this, "renderLoader", () => /*#__PURE__*/_jsx("div", {
      className: "u-flexbox u-justify-content-center",
      children: /*#__PURE__*/_jsx(Loader, {
        size: Loader.Size.Large
      })
    }));

    _defineProperty(this, "renderFilters", () => {
      const {
        catalogs,
        filters
      } = this.props;
      return /*#__PURE__*/_jsxs("div", {
        className: "u-text-left u-flexbox u-flex-wrap",
        children: [/*#__PURE__*/_jsx(CatalogFilter, {
          catalogs: catalogs,
          selectedId: filters.catalogId,
          toggleCatalogFilterOption: this.handleFilterChange('catalogId')
        }), /*#__PURE__*/_jsx(SortFilter, {
          selected: filters.sortBy,
          onItemClick: this.handleFilterChange('sortBy')
        })]
      });
    });

    _defineProperty(this, "renderSellerFilters", () => {
      const {
        catalogs
      } = this.props;
      if (!this.isViewingSelf() && catalogs.length) return this.renderFilters();
      return null;
    });

    _defineProperty(this, "renderItems", () => {
      const {
        selectedFilter
      } = this.state;
      const {
        items,
        totalItemsCount,
        itemsCount,
        breakpoints
      } = this.props;
      const hasItems = totalItemsCount > 0;
      const Wrapper = breakpoints.tabletsUp ? props => /*#__PURE__*/_jsx("div", _objectSpread({}, props)) : Fragment;
      const desktopRowClass = classNames('u-flexbox u-flex-wrap u-align-items-center', {
        'u-justify-content-between': hasItems,
        'u-justify-content-flex-end': !hasItems
      });
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(Container, {
          children: [/*#__PURE__*/_jsxs("div", {
            className: desktopRowClass,
            children: [hasItems && /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsxs(Wrapper, {
                children: [/*#__PURE__*/_jsx(Text, {
                  type: Text.Type.Title,
                  text: /*#__PURE__*/_jsx(FormattedMessage, {
                    id: "user.items.title",
                    values: {
                      count: itemsCount
                    }
                  })
                }), /*#__PURE__*/_jsx(Spacer, {
                  orientation: Spacer.Orientation.Vertical
                })]
              }), this.renderSellerFilters()]
            }), this.isViewingSelf() && /*#__PURE__*/_jsx("div", {
              className: "u-tablets-up-only",
              children: /*#__PURE__*/_jsx(UserItemsFilters, {
                onFilterClick: this.handleUserItemsFilterClick,
                selectedFilter: selectedFilter
              })
            })]
          }), this.isViewingSelf() && /*#__PURE__*/_jsx("div", {
            className: "u-phones-only",
            children: /*#__PURE__*/_jsx(UserItemsFilters, {
              onFilterClick: this.handleUserItemsFilterClick,
              selectedFilter: selectedFilter
            })
          })]
        }), items.length > 0 && /*#__PURE__*/_jsx("div", {
          className: "u-ui-margin-horizontal-regular@portables",
          children: /*#__PURE__*/_jsx(InfiniteScroll, {
            renderItems: this.renderItemsContainer,
            onPageEnd: this.fetchMoreItems,
            cursor: "user-items-".concat(itemsCount)
          })
        })]
      });
    });
  }

  componentDidMount() {
    this.setState({
      isClientSideReady: true
    });
    const {
      track,
      exposee,
      closetFilteringAbTest,
      isClosetFilteringEnabled
    } = this.props;

    if (closetFilteringAbTest && this.isViewingSelf() && isClosetFilteringEnabled) {
      track(abTestExposeEvent(_objectSpread(_objectSpread({}, exposee), closetFilteringAbTest)));
    }
  }

  renderEmptyState() {
    const {
      userOnHoliday,
      closetFilteringAbTest,
      isClosetFilteringEnabled
    } = this.props;
    const animation = userOnHoliday ? 'vacation' : 'closet';

    if ((closetFilteringAbTest === null || closetFilteringAbTest === void 0 ? void 0 : closetFilteringAbTest.variant) === 'on' && isClosetFilteringEnabled && this.isViewingSelf()) {
      const animationUrl = '/assets/animations/closet-empty-state.json';
      return /*#__PURE__*/_jsx(EmptyState, {
        animation: /*#__PURE__*/_jsx(Animation, {
          animationUrl: animationUrl
        }),
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          id: "profile.items_empty_state.self_view.title"
        }),
        body: /*#__PURE__*/_jsx(FormattedMessage, {
          id: "profile.items_empty_state.self_view.subtitle"
        }),
        action: /*#__PURE__*/_jsx(Button, {
          text: /*#__PURE__*/_jsx(FormattedMessage, {
            id: "profile.items_empty_state.button"
          }),
          url: ITEM_UPLOAD_URL,
          styling: Button.Styling.Filled
        })
      });
    }

    return /*#__PURE__*/_jsx(EmptyState, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        id: "user.items_empty.title"
      }),
      body: userOnHoliday ? /*#__PURE__*/_jsx(FormattedMessage, {
        id: "user.items_empty.on_holiday"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        id: "user.items_empty.no_items"
      }),
      animation: /*#__PURE__*/_jsx(Animation, {
        animationUrl: "".concat(STATIC_ASSETS_URL, "/assets/animations/").concat(animation, "-empty-state.json")
      })
    });
  }

  render() {
    const {
      items,
      isLoading
    } = this.props;
    const showEmptyState = isEmpty(items) && !isLoading;
    const showLoader = isLoading;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [this.renderItems(), showEmptyState && this.state.isClientSideReady && this.renderEmptyState(), showLoader && this.renderLoader()]
    });
  }

}

export default withBreakpoint(withTracking(connector(UserItems)));